import { List, Create, Edit, View, Barcode } from "../Components/index.js";

export default [
    {
        path: "/canteen/remote-ledger",
        component: List,
        name: "canteen-remote-ledger",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/remote-ledger/create",
        component: Create,
        name: "canteen-remote-ledger-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/remote-ledger/:id/edit",
        component: Edit,
        name: "canteen-remote-ledger-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/remote-ledger/:id/view",
        component: View,
        name: "canteen-remote-ledger-view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/remote-ledger-barcode",
        component: Barcode,
        name: "canteen-remote-ledger-barcode",
        meta: {
            requiresAuth: true,
        },
    },
];
